import { Button } from "../../../components/ui"
import { handleEvaluationButtonClick } from "../../../utils/redirectToNewReview"

export const HowItWorks = ({showEvaluationPart = true}: {showEvaluationPart?: boolean}) => {
  return (
    <div className="bg-primary py-10 text-center px-4" id="how-it-works">
      <h2 className="text-white text-center">
        Comment ça fonctionne ?
      </h2>
      <p className="text-white text-center mt-2">
        Aucune influence de marque. Aucune manipulation. Uniquement des avis honnêtes.
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-8 mx-auto lg:max-w-[70%]">
        <HowItWorksStep />
      </div>
      {showEvaluationPart && (
        <>
          <h2 className="text-white text-center mt-8 mb-6">
            Prêt(e) à partager votre expérience ?
          </h2>
          <Button
            size="lg"
            variant="white"
            onClick={() => handleEvaluationButtonClick({ page_type: "Comment ça fonctionne ?" })}
          >
            Évaluer mon véhicule en 2 minutes
          </Button>
        </>
      )}
    </div>
  )
}

export const HowItWorksStep = () => {
  const howItWorksData = [
    {
      step: 1,
      title: "Entrez votre immatriculation",
      description: "Il vous suffit d'entrer le numéro d'immatriculation de votre véhicule pour commencer.",
    },
    {
      step: 2,
      title: "Vérifiez votre véhicule",
      description: "Notre système vérifie que votre véhicule existe et associe votre avis au bon modèle."
    },
    {
      step: 3,
      title: "Notez votre véhicule",
      description: "Partagez votre expérience en seulement 2 minutes grâce à un questionnaire simple et intuitif.",
    }
  ]
  return (
    <>
    {howItWorksData.map((step, index) => (
    <div key={index} className="bg-white col-span-1 shadow-md rounded-md p-4 flex flex-col gap-4 py-6">
      <div className="rounded-full h-10 w-10 bg-primary/10 text-white flex items-center justify-center mx-auto">
        <span className="primary-color font-bold">
          {index + 1}
        </span>
      </div>
      <h3 className="primary-color text-center font-bold">
        {step.title}
      </h3>
      <p className="text-muted-foreground text-center">{step.description}</p>
    </div>
  ))}
  </>
  )
}

